import { axiosInstance } from '../../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../../Shared/Utils/UrlConstants';

const Service = {
  forgotPassword: (data) => {
    return axiosInstance.post(ApiUrlConstant.forgotPasswordService(), data, { loaderKey: 'forgot-password' });
  },
};

export default Service;
